import { render, staticRenderFns } from "./Users-Info.vue?vue&type=template&id=53b55da7&scoped=true&"
import script from "./Users-Info.vue?vue&type=script&lang=js&"
export * from "./Users-Info.vue?vue&type=script&lang=js&"
import style0 from "./Users-Info.vue?vue&type=style&index=0&id=53b55da7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b55da7",
  null
  
)

export default component.exports